<template>
  <div class="application" :style="{ backgroundColor: '#fff' }">
    <div class="application__header">
      <h1 class="application__title">Candidatura Realizada</h1>
    </div>
    <div class="application__content">
      <lottie-player
        src="https://assets3.lottiefiles.com/packages/lf20_QKHsU2.json"
        background="transparent"
        speed="1"
        style="width: 170px; height: 170px"
        autoplay
      >
      </lottie-player>
      <div class="application__description">
        <!-- <h1>Desenvolvedor Front-End Pleno</h1> -->
        <p>Fique atento a sua caixa de entrada.</p>
        <p>
          A empresa pode usar o email para te avisar sobre <br />
          as próximas etapas do processo seletivo.
        </p>
        <br />
        <p>
          Gostou da experiência de cadastro?<br />
          Vamos adorar saber disso!<br />
          Publique em suas redes a hashtag <br /><b>#EmpregoNaRecrutei</b><br /><br />E
          conte como foi <br />sua experiência!
        </p>
      </div>
      <div class="application__push">
        <EnablePushNotificationsCard source="application_success_page" />
      </div>
    </div>
    <div class="application__actions">
      <div
        class="md:hidden mobile-button"
        :style="{ color: color }"
        @click="
          $router.push({
            name: isAnonimous ? 'dashboard-vacancy' : 'dashboard-profile-detail',
          })
        "
      >
        ÁREA DO CANDIDATO
      </div>
      <vs-button
        class="mobile-hidden"
        size="large"
        color="primary"
        type="filled"
        @click="
          $router.push({
            name: isAnonimous ? 'dashboard-vacancy' : 'dashboard-profile-detail',
          })
        "
      >
        Área do Candidato
      </vs-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EnablePushNotificationsCard from "../dashboard/EnablePushNotificationsCard.vue";

export default {
  name: "success-application-card",
  components: { EnablePushNotificationsCard },
  computed: {
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    isAnonimous() {
      const { company_label } = this.$router.history.current.params;
      return company_label === "anonima";
    },
  },
  created() {
    this.$store.dispatch("step/clearStepsState");
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/application.scss";

.application__push {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  text-align: left;
}

.mobile-button {
  /** display */
  display: flex;
  align-items: center;
  justify-content: center;

  /** box model */
  min-width: 100vw;
  min-height: 4rem;
  padding: 1rem;

  /** background */
  background-color: white;

  /** typography */
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1rem;
}
</style>
